import type { HeroCarouselNewItem } from 'src/components/sections/HeroCarousel/hero-carousel'
import { CTA } from './CTA'
import { Description } from './Description'
import { TagList } from './TagList'
import { Title } from './Title'

type Props = {
  item: HeroCarouselNewItem
}

export const Content = ({ item }: Props) => {
  const hasSameBgAsSlide =
    item.content.backgroundColor === item.content.button.styles?.backgroundColor

  return (
    <div
      className="flex flex-col gap-1 rounded-b-md p-4 md:p-6 whitespace-normal break-words flex-grow"
      style={{ backgroundColor: item.content.backgroundColor }}
    >
      <TagList tags={item.content.tag} />
      <Title title={item.content.title} />
      <Description description={item.content.description} />
      <CTA
        label={item.content.button.label}
        styles={item.content.button.styles}
        hasSameBgAsSlide={hasSameBgAsSlide}
      />
    </div>
  )
}
